var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-12" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "card-tools" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.onDownloadData }
              },
              [
                _c("i", { staticClass: "fas fa-file-download" }),
                _vm._v(" Download\n                    ")
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-info",
                attrs: {
                  type: "button",
                  href:
                    "/orders/create?context=" +
                    this.context +
                    "&context_id=" +
                    this.context_id
                }
              },
              [_vm._v("Create Order")]
            )
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Orders")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("p", [
            _vm._v(
              "When you submit an order, it will be processed by the system and may take a few minutes to appear. You will also receive an email confirmation."
            )
          ]),
          _vm._v(" "),
          _c("div", { ref: "table" })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }